/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_eeeec892"]'><div :class='["modal-content-slot-demo"]'><cube-modal ref="__mpx_ref_modal__" direction="horizontal" title="我是标题~" content="我是正文~" :mask-closable="(true)" :no-built-in-btns="(true)" @confirm='(e)=>__invoke(e, [["onConfirm"]])'><div slot="content" :class='["modal-content"]'><div :key="item.index" v-for="(item, index) in (list)" :class='["modal-content-btn"]'><cube-button @_click="clickItem(item)">{{ item }}</cube-button></div></div></cube-modal><cube-button @_click="onTap">modal-content-slot</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_eeeec892"}'>
.modal-content-slot-demo
  .modal-content-btn
    margin-bottom 10px
    .cube-btn
      font-size 17px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_eeeec892"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_eeeec892"}
  /** script content **/
  require("./modal-content-slot.mpx.js?isComponent&outputPath=components%2Fmodal-content-sloteeeec892%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-content-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-content-sloteeeec892%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_eeeec892"],
    ctorType: "component",
    outputPath: "components/modal-content-sloteeeec892/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>